<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <ItpBox
    alignItems="center"
    class="mb-2"
  >
    <strong>
      {{ 'Versions'|pgettext('Register') }}
    </strong>
  </ItpBox>
  <ItpDataTable
    rowKeyField="id"
    tableId="registerVersions"
    :paging="b_5962862420439144_paging"
    :editable="!register.isReadonly"
    :sortable="b_5962862420439144_sortable"
    :value="register.versions.data"
    :rowTemplate="b_5962862420439144_rowTemplate"
    :columns="b_5962862420439144_columns"
    v-if="register.versions.data"
    @save="evh_5962862420439144_save($event, {})"
    @save-completed="evh_5962862420439144_saveCompleted($event, {})"
    @delete="evh_5962862420439144_delete($event, {})"
    @delete-completed="evh_5962862420439144_deleteCompleted($event, {})"
  >
  </ItpDataTable>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcRegisterVersions extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  register!: object;

  @Watch('register')
  onRegister(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("register")
  }

  ux!: any;
  b_5962862420439144_paging!: any;
  b_5962862420439144_sortable!: any;
  b_5962862420439144_rowTemplate!: any;

  async $$load_b_5962862420439144_rowTemplate() {
    return {
      register_id: this.register.id,
    }
  }

  b_5962862420439144_columns!: any;
  dataMembers = ['ux', 'b_5962862420439144_paging', 'b_5962862420439144_sortable', 'b_5962862420439144_rowTemplate', 'b_5962862420439144_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ux: null,
        b_5962862420439144_paging: false,
        b_5962862420439144_sortable: false,
        b_5962862420439144_rowTemplate: null,
        b_5962862420439144_columns: [{
          name: "name",
          header: this.$fn.pgettext("RegisterVersion", "Name"),
          width: "110px",
          required: true,
        }
          ,
        {
          name: "financial_year",
          width: "70px",
          header: this.$fn.pgettext("RegisterVersion", "Financial year"),
          type: "number",
          textAlign: "right",
          required: true,
        }
          ,
        {
          name: "number_format",
          width: "130px",
          header: this.$fn.pgettext("RegisterVersion", "Number format"),
          type: "textarea",
          required: true,
        }
          ,
        {
          name: "current_value",
          width: "80px",
          header: this.$fn.pgettext("RegisterVersion", "Current value"),
          type: "number",
          textAlign: "right",
          required: true,
        }
          ,
        {
          name: "increment",
          width: "80px",
          header: this.$fn.pgettext("RegisterVersion", "Increment"),
          type: "number",
          textAlign: "right",
          required: true,
        }
          ,
        ]
        ,
      },
    }
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  async act_5962862420439144_script_8220_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5962862420439144_script_8220, alias=undefined
    $event.data.waitFor(
      this.$fn.crud('register_version').upsert($event.data.row)
    )
  }

  async act_5962862420439144_script_8220_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5962862420439144_script_8220, alias=undefined
    return {
      value: () => this.act_5962862420439144_script_8220_getActionArgs_value($event),
    }
  }

  async evh_5962862420439144_save(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_save.executeFromDOM(this, event, scope);
  }

  async act_5962862420439144_emit_8222_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_5962862420439144_emit_8222, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_5962862420439144_saveCompleted(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_saveCompleted.executeFromDOM(this, event, scope);
  }

  async act_5962862420439144_script_8224_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5962862420439144_script_8224, alias=undefined
    $event.data.waitFor(this.$fn.crud('invoice_line_meter_accounting').delete($event.data.row))
  }

  async act_5962862420439144_script_8224_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5962862420439144_script_8224, alias=undefined
    return {
      value: () => this.act_5962862420439144_script_8224_getActionArgs_value($event),
    }
  }

  async evh_5962862420439144_delete(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_delete.executeFromDOM(this, event, scope);
  }

  async act_5962862420439144_emit_8226_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_5962862420439144_emit_8226, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_5962862420439144_deleteCompleted(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_deleteCompleted.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_8218: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_8217: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
    act_5962862420439144_script_8220: actions.ScriptAction;
    evh_5962862420439144_save_8219: actions.EventHandlerImpl;
    evh_5962862420439144_save: actions.EventHandlerGroup;
    act_5962862420439144_emit_8222: actions.EmitAction;
    evh_5962862420439144_saveCompleted_8221: actions.EventHandlerImpl;
    evh_5962862420439144_saveCompleted: actions.EventHandlerGroup;
    act_5962862420439144_script_8224: actions.ScriptAction;
    evh_5962862420439144_delete_8223: actions.EventHandlerImpl;
    evh_5962862420439144_delete: actions.EventHandlerGroup;
    act_5962862420439144_emit_8226: actions.EmitAction;
    evh_5962862420439144_deleteCompleted_8225: actions.EventHandlerImpl;
    evh_5962862420439144_deleteCompleted: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_8218 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_8217 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_8218,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_8217],
      }
    );
    const act_5962862420439144_script_8220 = new actions.ScriptAction(
      {
        actionArgs: this.act_5962862420439144_script_8220_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_save_8219 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_script_8220,
        event: "save",
        displayName: "script",
      }
    );
    const evh_5962862420439144_save = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_save_8219],
      }
    );
    const act_5962862420439144_emit_8222 = new actions.EmitAction(
      {
        actionArgs: this.act_5962862420439144_emit_8222_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_saveCompleted_8221 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_emit_8222,
        event: "save-completed",
        displayName: "emit",
      }
    );
    const evh_5962862420439144_saveCompleted = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_saveCompleted_8221],
      }
    );
    const act_5962862420439144_script_8224 = new actions.ScriptAction(
      {
        actionArgs: this.act_5962862420439144_script_8224_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_delete_8223 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_script_8224,
        event: "delete",
        displayName: "script",
      }
    );
    const evh_5962862420439144_delete = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_delete_8223],
      }
    );
    const act_5962862420439144_emit_8226 = new actions.EmitAction(
      {
        actionArgs: this.act_5962862420439144_emit_8226_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_deleteCompleted_8225 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_emit_8226,
        event: "delete-completed",
        displayName: "emit",
      }
    );
    const evh_5962862420439144_deleteCompleted = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_deleteCompleted_8225],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_8218,
      evh_7315092382398562_reload_8217,
      evh_7315092382398562_reload,
      act_5962862420439144_script_8220,
      evh_5962862420439144_save_8219,
      evh_5962862420439144_save,
      act_5962862420439144_emit_8222,
      evh_5962862420439144_saveCompleted_8221,
      evh_5962862420439144_saveCompleted,
      act_5962862420439144_script_8224,
      evh_5962862420439144_delete_8223,
      evh_5962862420439144_delete,
      act_5962862420439144_emit_8226,
      evh_5962862420439144_deleteCompleted_8225,
      evh_5962862420439144_deleteCompleted,
    }
  }
}

Vue.component("UcRegisterVersions", UcRegisterVersions);

</script>